module.exports = __webpack_public_path__ + "static/media/dr4-winners.48f25817.jpg";